import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormControl,
} from '@angular/forms';
import { HomeService } from '../../../../services/home.service';

import { DialogService } from '../../../../services/dialog.service';
import { ToastService } from '../../../../services/toast.service';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-home',
  templateUrl: './adm-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmHomeComponent implements OnInit {
  submitted = false;
  error = '';
  formHome: UntypedFormGroup;
  public home: any;

  //public Editor = ClassicEditor;

  constructor(
    private homeService: HomeService,
    private authorizeService: AuthService,
    private dialogService: DialogService,
    private toastService: ToastService,
    private router: Router
  ) { }

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user != null) {
      this.createForm();
    } else {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/adm/home' }
      });
    }
  }

  get f() {
    return this.formHome.controls;
  }

  createForm() {
    this.homeService.get().subscribe((home) => {
      this.home = home;
      this.formHome = new UntypedFormGroup({
        id: new UntypedFormControl(this.home.id),
        titulo: new UntypedFormControl(this.home.titulo),
        textoPrincipal: new UntypedFormControl(this.home.textoPrincipal),
        textoSobre: new UntypedFormControl(this.home.textoSobre),
        foto: new UntypedFormControl(this.home.foto),
        linkedin: new UntypedFormControl(this.home.linkedin),
        gitHub: new UntypedFormControl(this.home.gitHub),
        twitter: new UntypedFormControl(this.home.twitter),
      });
    });
  }

  submitForm() {
    this.submitted = true;
    this.home = this.formHome.value;
    if (this.formHome.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.homeService.put(this.home.id, this.home).subscribe({
      next: () => {
        this.toastService.show('Sucesso ao executar!', { type: 'success' });
      },
      error: () => {
        this.toastService.show('Erro ao executar!', { type: 'danger' });
      },
    });
  }

  reloadCurrentPage() {
    window.location.reload();
  }
}
